<template>
    <div class="">
        <div class="w-100 d-flex gap-1 justify-content-between align-items-center">
            <div v-if="!isInProgress" class="w-40 d-flex gap-1 align-items-center justify-content-between">
                <div class="w-40 d-flex flex-column gap-1 align-items-center justify-content-between">
                    <div class="">
                        <b-badge
                            :variant="sub.state.color_variant"
                            class="text-uppercase"
                            v-b-tooltip.hover.top
                            :title="sub.state.title"
                        >
                            {{ sub.state.badge_title }}
                        </b-badge>
                    </div>
                    <div class="d-flex gap-2">
                        <div 
                            v-b-tooltip.hover.bottom 
                            title="Date Added" 
                            class="font-size-70 text-muted"
                        >{{ formatDate(sub.created, '-') }}</div>
                    </div>
                </div>
                <!-- <div class="bg-gray-300 h-100" style="width: 1px;"></div> -->
                <div class="w-60 text-center">
                    <div v-if="!isInProgress" class="w-100">
                        <h6 class="item-heading mb-1">{{ isFutureDate(sub.valid_to) ? 'Expires' : 'Expired' }} On</h6>
                        <div class="">{{ formatDate(sub.valid_to_date_tenant_tz, 'NOT SET') }}</div>
                    </div>
                </div>
            </div>
            <!-- <div class="bg-gray-300" style="width: 1px; height: 30px;"></div> -->
            <div v-if="!isInProgress" class="w-60">
                <base-s-3-file-download-button-group
                    :fileData="sub.files"
                    :button-props="{
                        block: true,
                        buttonVariant: 'subtle-primary',
                        hideFilesize: true,
                    }"
                    vertical
                    class="w-100"
                ></base-s-3-file-download-button-group>
            </div>
            <div v-if="isInProgress" class="w-100 d-flex align-items-center gap-2">
                <div class="w-30 text-center">
                    <span class="text-uppercase font-scale-70 border rounded-lg px-2 py-1 bg-gray-100">
                        <b-icon 
                            icon="circle-fill" 
                            animation="throb" 
                            scale="1" 
                            variant="primary-600" 
                            :style="{marginRight: '2px'}"
                        ></b-icon>
                        In Progress
                    </span>
                </div>
                <div class="w-70 special-text font-size-80 text-center">
                    {{ inProgressText }}  <!-- TODO - add special styling to the overall component too, show stepper of progress... -->
                </div>
            </div>
            <div class="flex-shrink-1">
                <b-dropdown 
                    size="lg" 
                    right 
                    variant="subtle-dark" 
                    toggle-class="text-decoration-none rounded-pill p-0" 
                    style="height: 2rem; width: 2rem;" 
                    no-caret
                    @show="onDropdownShow"
                >  <!-- NOTE: the @show event is getting fired multiple times in quick succession... not sure why.... -->
                    <template #button-content>
                        <b-icon icon="three-dots-vertical"></b-icon>
                        <span class="sr-only">Actions</span>
                    </template>
                    <template v-if="!transitionsLoaded || loadingTransitions">
                        <b-dropdown-item disabled class="width-300 d-flex align-items-center justify-content-center gap-2">
                            <!-- <b-skeleton width="100%" height="2rem"></b-skeleton> -->
                            <b-spinner small class="mr-1"></b-spinner>
                            <span>Loading...</span>
                        </b-dropdown-item>
                    </template>
                    <template v-else-if="actionTransitions.length === 0">
                        <b-dropdown-item disabled class="width-300 text-muted special-text font-size-70">No Actions Available</b-dropdown-item>
                    </template>
                    <template v-else>
                        <b-dropdown-item 
                            v-for="trans in actionTransitions" 
                            :key="trans.trigger"
                            link-class="px-2 d-flex align-items-center gap-2" 
                            class="width-300"
                            @click="startTransition(trans)"
                        >
                            <b-icon 
                                :icon="trans.icon" 
                                :variant="trans.color_variant" 
                                class="rounded-circle" 
                                :class="['bg-' + (trans.color_variant || 'primary') + '-100']" 
                                style="padding: 6px;" 
                                font-scale="2"
                            ></b-icon>
                            <div class="text-wrap line-height-110">
                                <div class="font-weight-500">{{ trans.label }}</div>
                                <div class="text-muted font-size-70">{{ trans.description }}</div>
                            </div>
                        </b-dropdown-item>
                    </template>
                </b-dropdown>
            </div>
        </div>
        <div 
            v-if="sub.notes" 
            class="container-fluid pt-2 border-top border-light2 mt-2"
        >
            <div class="row">
                <div class="col-2 d-flex flex-column justify-content-center">
                    <h6 class="item-heading text-right mb-0">Notes</h6>
                </div>
                <div class="col line-height-110 font-size-70 text-muted text-left">
                    {{ sub.notes }}
                </div>
            </div>
        </div>
        <div 
            v-if="nodesToShow.length" 
            class="container-fluid pt-2 border-top border-light2 mt-2"
        >
            <!-- <hr class="bg-gray-200"> -->
            <div class="row">
                <!-- <div class="col-12 d-flex justify-content-center align-items-center gap-2 my-2"> -->
                <div class="col-2 d-flex flex-column justify-content-center">
                    <!-- <hr class="flex-grow-1"> -->
                    <h6 class="item-heading text-right mb-0">Pending Tasks</h6>
                    <!-- <hr class="flex-grow-1"> -->
                </div>
                <div class="col">
                    <!-- <div class="d-flex flex-column gap-1">
                        <div 
                            v-for="node in nodesToShow"
                            :key="node.key"
                            class="border rounded-lg overflow-hidden"
                        >
                            <b-button 
                                variant="zone-primary"
                                block
                                class="font-size-70 w-100 border rounded bg-gray-50 px-3 py-1"
                                @click="openNodeDetail(node)"
                            >
                                <div class="w-100 font-size-70 d-flex align-items-center justify-content-center">
                                    <b-iconstack class="mr-1" font-scale="1.25">
                                        <b-icon icon="circle-fill" class="text-primary-200"></b-icon>
                                        <b-icon icon="circle-fill" animation="throb" variant="primary" scale="0.5"></b-icon>
                                    </b-iconstack>
                                    <div class="font-weight-500">{{ node.title }}</div>
                                </div>
                                <div v-if="node.description" class="text-muted mt-1 font-size-70 text-center">{{ node.description }}</div>
                            </b-button> -->
                            <!-- MAYBE SHOW SOME THINGS IN COLLAPSE, SOME THINGS IN MODAL (of different sizes) 
                            approvals show inline in collapse?
                            supplier-side stuff show in modal so you can have bigger forms, otherwise its too cramped
                            -->
                            <!-- <b-collapse :id="`inline-node-${subId}-${node.key}`" class="p-3" v-model="nodeModalShowing">
                                <div 
                                    v-if="nodeTransitionResult && nodeTransitionResult.message" 
                                    :key="`${activeNode.key}-completedMessage`" 
                                    :class="nodeTransitionResult.success ? 'text-success' : 'text-danger'" 
                                    class="d-flex align-items-center justify-content-center"
                                >
                                    <div class="text-center">
                                        {{ nodeTransitionResult.message }}
                                    </div>
                                </div>
                                <CompSubNode
                                    v-else-if="activeNode.key === node.key"
                                    :key="activeNode.key"
                                    :flowObject="subFlowObject"
                                    :nodeKey="activeNode.key"
                                    class="w-100 h-100"
                                    @updated="handleNodeUpdated"
                                    @transition-completed="handleNodeTransitionCompleted"
                                ></CompSubNode>
                            </b-collapse> -->
                        <!-- </div>
                    </div> -->
                    <b-list-group>
                        <b-list-group-item
                            v-for="node in nodesToShow"
                            :key="node.key"
                            button
                            class="py-2 px-3 bg-gray-100 hover-shadow"
                            :style="{borderLeft: node.showIsAssignedTu ? '6px solid var(--primary)' : ''}"
                            @click="openNodeDetail(node)"
                        >
                            <div class="d-flex justify-content-between gap-3">
                                <div class="text-left">
                                    <div class="font-weight-500">{{ node.title }}</div>
                                    <div v-if="node.description" class="text-muted mt-1 font-size-70">{{ node.description }}</div>
                                </div>
                                <div class="text-right">
                                    <ActiveAssigneeChip
                                        :variant="node.isAssignedTu ? 'warning' : 'secondary'"
                                        :text="node.isAssignedTu ? 'You' : (node.isSupplierTask ? 'Supplier' : 'Internal')"
                                        :tooltip="node.isAssignedTu ? 'Waiting on your action' : (node.isSupplierTask ? 'Waiting on supplier action' : 'Waiting on internal action')"
                                        :noIcon="!node.showIsAssignedTu"
                                    ></ActiveAssigneeChip>
                                    <div v-if="node.deadlineTimeUntil" class="text-muted font-size-70 mt-1">{{ node.deadlineTimeUntil }}</div>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
        </div>
        <b-modal
            v-model="transModalShowing"
            centered
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            size="md"
            @hidden="afterTransModalHidden"
        >  <!-- can make modal size dynamic, but we only know that based on the detail loaded in the FlowObjectTransitionForm component... so we don't easily have it here -->
            <FlowObjectTransitionForm
                :key="activeTransition.trigger"
                :flowObject="subFlowObject"
                :trigger="activeTransition.trigger"
                :hideCancel="false"
                :autoStart="true"
                :noReloadOnSuccess="true"
                :minHeight="'150px'"
                @loading-start="handleTransitionFormEvent"
                @loading-end="handleTransitionFormEvent"
                @loading-error="handleTransitionFormEvent"
                @transition-start="handleTransitionFormEvent"
                @transition-error="handleTransitionFormEvent"
                @transition-success="handleTransitionFormEvent"
                @transition-end="handleTransitionFormEvent"
                @cancel="handleTransitionFormCancel"
            ></FlowObjectTransitionForm>
        </b-modal>

        <b-modal
            v-model="nodeModalShowing"
            centered
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
            size="lg"
            body-class="bg-gray-100 p-0"
            :title="activeNodeTitle"
            @hidden="afterNodeModalHidden"
        >  <!-- add something to the title of modal to show context -->
            <div class="h-100 w-100 p-3">
                <div 
                    v-if="nodeTransitionResult && nodeTransitionResult.message" 
                    :key="`${activeNode.key}-completedMessage`" 
                    :class="nodeTransitionResult.success ? 'text-success' : 'text-danger'" 
                    class="h-100 min-height-400 d-flex align-items-center justify-content-center"
                >
                    <div class="text-center font-size-110 font-weight-500">
                        {{ nodeTransitionResult.message }}
                    </div>
                </div>
                <CompSubNode
                    v-else
                    :key="activeNode.key"
                    :flowObject="subFlowObject"
                    :nodeKey="activeNode.key"
                    class="w-100 h-100"
                    @updated="handleNodeUpdated"
                    @transition-completed="handleNodeTransitionCompleted"
                ></CompSubNode>
                <!-- flowObjectClass="ComplianceSubmission"
                    :flowObjectId="subId" -->
            </div>
        </b-modal>
    </div>
</template>

<script>
import { 
    FormatDateHelper, 
    // luxonDurationToHumanizedString, 
    isFutureDate,
} from '@/js/filters-helpers';
// import cloneDeep from 'lodash/cloneDeep';
import { errorHandling, currentUserInfoMixin } from '@/js/custom-vue-mixins';
import { FlowObject } from '@/components/flows/models/flowObject';
import FlowObjectTransitionForm from '@/components/flows/components/FlowObjectTransitionForm.vue'; //'../../flows/components/FlowObjectTransitionForm.vue';
// import SoloFlowNode from '@/components/flows/components/SoloFlowNode.vue';  // '../../flows/components/SoloFlowNode.vue';
import CompSubNode from './CompSubNode.vue';
import ActiveAssigneeChip from '../shared/ActiveAssigneeChip.vue';

export default {
    name: 'CompSubSingle',
    components: {
        FlowObjectTransitionForm,
        // SoloFlowNode,
        CompSubNode,
        ActiveAssigneeChip,
    },
    mixins: [
        errorHandling,
        currentUserInfoMixin,  // provides currentTuId
    ],
    props: {
        sub: {  // may be a PARTIAL submission object, may not have all details
            // TODO - either always get data from parent, or always get locally (only id from parent)
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            subFlowObject: null,  // the FlowObject() instance for this submission
            // NOT NEEDED? localSubData: {},  // local copy of data -- we start with data from prop, but replace it with data from FlowObject when we get that
            transModalShowing: false,
            activeTransition: {},  // the active transition object, set when we start a transition
            nodeModalShowing: false,  // show the node modal
            activeNode: {},  // the active node object, set when we open a node modal
            nodeTransitionResult: {},  // { success: bool, message: string } - set when we get a result from a node transition
        }
    },
    computed: {
        subId() {
            return this.sub.id;
        },
        anyLoading() {
            return this.loadingNodes || this.loadingTransitions;
        },
        loadingNodes() {
            return this.subFlowObject.loadingNodes;
        },
        nodesByZone() {
            return this.subFlowObject.getNodesByZone();
        },
        taskNodes() {
            return this.subFlowObject.getNodesForZone('tasks');
        },
        allActiveNodes() {
            // active nodes for ALL assignees (will only include the ones visible to current TU)
            return this.subFlowObject.getNodes({
                onlyActive: true,
            });
        },
        assignedActiveNodes() {
            // return the active nodes that are assigned to the current TU
            return this.subFlowObject.getNodes({
                assignedTuId: this.currentTuId,
                onlyActive: true,
            });
        },
        hasActiveAssignedNodes() {
            // return true if there are any active nodes assigned to the current TU
            return this.assignedActiveNodes.length > 0;
        },
        nodesToShow() {
            // return the nodes that are active and assigned to the current TU
            // for external users, we ONLY show the ones they are specifically assigned to
            // for internal users, we show all... but the ones not assigned to them will be read-only 
            // (for externals that would be the case too, but its too much info)
            return this.currentTuIsInternal ? this.allActiveNodes : this.assignedActiveNodes;
        },
        activeNodeTitle() {
            // the title to show in the modal for the activeNode 
            const title = this.activeNode.title || '';
            const subTitle = this.sub.display_name || '';
            return [title, subTitle].filter(t => t).join(' - ');
        },
        // TRANSITIONS
        transitionsLoaded() {
            return this.subFlowObject.isTransitionsLoaded;
        },
        loadingTransitions() {
            return this.subFlowObject.loadingTransitions;
        },
        hasActiveTransition() {
            return !!this.subFlowObject.activeTransition;
        },
        possibleTriggerNames() {
            // return this.transitions.map((transition) => {
            //     return transition.trigger;
            // });
            return this.subFlowObject.getPossibleTriggerNames();
        },
        transitionsByZone() {
            return this.subFlowObject.getTransitionsByZone();
        },
        actionTransitions() {
            console.log('starting actionTransitions in CompSubSingle - subId', this.subId);
            const actions = this.subFlowObject.getTransitionsForZone('actions');
            console.log('actionTransitions for subId', this.subId, 'actions:', actions);
            return actions;
        },
        currentTuId() {
            return this.$currentUserInfo?.tenant_user_id || '';
        },
        currentTuIsInternal() {
            return !!this.$currentUserInfo?.is_internal;
        },
        currentTuIsExternal() {
            // we don't check for explicit external... in case we don't get the currentUserInfo somehow... so we just check for NOT internal, which is safer
            return !this.currentTuIsInternal;
        },
        // STATE RELATED
        inProgressText() {
            // if in progress, what text to show - might be different based on internal/external user
            if (!this.isInProgress) {
                return '';
            }
            if (this.currentTuIsInternal) {
                if (this.isPendingInternalReview) {
                    return 'Pending Internal Review or Approval';
                } else if (this.isPendingSupplier) {
                    return 'Pending Supplier Action';
                } else {
                    return 'In Progress';
                }
            } else {
                if (this.isPendingInternalReview) {
                    return 'Pending Internal Review or Approval';
                } else if (this.isPendingSupplier) {
                    return 'Pending Supplier Action';
                } else {
                    return 'In Progress';
                }
            }
        },
        isInProgress() {
            return this.sub.is_in_progress || false;
        },
        isPendingInternalReview() {  // review or approval
            return this.sub.is_pending_internal_review || false;
        },
        isPendingSupplier() {
            return this.sub.is_pending_supplier || false;
        },
        isValid() {
            return this.sub.is_valid || false;
        },
    },
    created() {
        // NOT NEEDED? this.localSubData = cloneDeep(this.sub);
        this.subFlowObject = new FlowObject({id: this.subId, model_class: 'ComplianceSubmission', data: {}});  // set in created hook?
    },
    mounted() {
        // this.subFlowObject?.fetchAll();  // this is async -- just need nodes instead???  probably transitions too.... just get all for now
        // nothing to do here?  we get data from parent, only transitions here, and we only get those when we open the dropdown
        this.refresh();
        console.log('CompSubSingle mounted for subId', this.subId);
    },
    methods: {
        async refresh() {
            return Promise.all([
                this.fetchSubData(),
                this.loadNodes(),
                // this.loadTransitions(),
            ]);
        },
        updateAndRefresh() {
            // call this from any place where something happened and we need to refresh this component and tell parent we did something
            // make this async?  await the refresh here?  reset other things?
            this.$emit('updated');  // just tell parent to refresh stuff
            // should we just always have parent destroy us and remake us?  that would be simpler, but might be slower... TBD
            this.refresh();  // NOTE: if we just called a transition to remove this sub, it won't be in a visible state anymore, and these API calls will return a 404/403
        },
        async fetchSubData() {
            // NOTE: we might not need this?  (the data) -- but maybe children that we pass it to need it??? TBD...
            const subData = await this.subFlowObject.fetchData();  // we now return the data also
            console.log('CompSubSingle fetchSubData for subId', this.subId, 'data:', subData);
            // we overwrite (merge into?) the local data with the fetched data
            // make a JS class instance from it?  I think its a different structure...
            // maybe don't overwrite it, just tell parent we need to refresh, let it update us
            // this.localSubData = subData;
        },
        async onDropdownShow() {
            console.log('onDropdownShow for subId', this.subId, 'transitionsLoaded:', this.transitionsLoaded, 'loadingTransitions:', this.loadingTransitions);
            // called when the dropdown is shown
            // we have this here because the @show event is getting fired multiple times in quick succession... not sure why.... this is a hack to prevent double fetching
            if (!this.loadingTransitions) {
                console.log('NOT CURRENTLY LOADING - WILL CALL .loadTransitions() for subId', this.subId);
                await this.loadTransitions();
            }
        },
        async loadTransitions() {
            console.log('STARTING loadTransitions for subId', this.subId, 'transitionsLoaded:', this.transitionsLoaded, 'loadingTransitions:', this.loadingTransitions);
            // only trigger this when we open the dropdown!
            await this.subFlowObject.fetchTransitions();
            console.log('DONE WITH loadTransitions for subId', this.subId, 'transitionsLoaded:', this.transitionsLoaded, 'loadingTransitions:', this.loadingTransitions);
        },
        async loadNodes() {
            await this.subFlowObject.fetchNodes();
        },
        // SUBMISSION TRANSITIONS
        async startTransition(transObj) {
            // start a transition for a submission
            console.log('startTransition', transObj);
            // const triggerName = transObj.trigger;
            this.activeTransition = transObj;  // set the active transition trigger
            this.transModalShowing = true;  // show the modal
        },
        resetTransition() {
            // utility to reset everything related to submission transition
            this.activeTransition = {};  // reset the active transition
        },
        afterTransModalHidden() {
            this.resetTransition();
        },
        handleTransitionFormCancel(payload) {
            console.log('handleTransitionFormCancel', payload);
            this.transModalShowing = false;  // close the modal -- then that will trigger the afterTransModalHidden to reset things
        },
        handleTransitionFormEvent(payload) {
            console.log('handleTransitionFormEvent', payload);
            const { event, trigger, activeTransition, error, responseData } = payload;
            // this thing handles ALL events from the transition modal... so we need to check the event type and do something with it
            // these are CompSub FLOW transitions, not node transitions
            // this.activeTransition = activeTransition; // make sure this plays nice with other stuff?  how to make sure we don't collide?
            console.log('handleTransitionFormEvent - event, trigger, activeTransition, error, responseData', event, trigger, activeTransition, error, responseData);
            if (event === 'transition-success') {
                this.transModalShowing = false;  // close the modal
                // this.$emit('updated');  // what payload to include?
                this.updateAndRefresh();
            }
        },
        // WORKING WITH NODES
        async openNodeDetail(node) {
            // open a node detail modal
            console.log('openNodeDetail', node);
            this.activeNode = node;  // set the active node
            this.nodeModalShowing = true;  // show the modal
            this.nodeTransitionResult = {};  // reset result
        },
        resetNode() {
            // utility to reset everything related to node detail
            this.activeNode = {};  // reset the active node
            this.nodeTransitionResult = {};  // reset result obj
        },
        afterNodeModalHidden() {
            this.resetNode();
        },
        // no specific cancel handler... just let the modal close and reset the node
        handleNodeUpdated(payload) {
            // NOTE: the 'updated' event from a node just means that some node was updated, but not a node transition
            // so it could be a form being saved, etc.
            // we don't really need to do anything with those here... we will only tell parent when we have a node transition completed
            // handle node updated event from the node detail modal
            console.log('handleNodeUpdated', payload);
            // this.activeNode = payload.node;  // update the active node with the new data
            // this.$emit('node-updated', payload);  // emit an event to parent to refresh stuff?
            // this.$emit('updated');  // just tell parent to refresh stuff
        },
        handleNodeTransitionCompleted(payload) {
            // TODO - likely needs works...
            // handle node transition completed event from the node detail modal
            console.log('handleNodeTransitionCompleted', payload);  // will be { success (bool), message (string) }
            this.nodeTransitionResult = payload;  // set the node transition result
            setTimeout(() => {
                // this.$emit('node-transition-completed', payload);  // emit an event to parent to refresh stuff?
                this.nodeModalShowing = false;  // close the modal
                // this.$emit('updated');  // just tell parent to refresh stuff
                this.updateAndRefresh();
            }, 2000);  // wait a bit to let the modal update
        },
        // FORMATTING FUNCTIONS
        formatDate(dateString, defaultText = '-') {
            return dateString ? FormatDateHelper(dateString) : defaultText;
        },
        isFutureDate(dateString) {
            if (!dateString) {
                return true;  // we return true here so things say 'Expires' if not set
            }
            return isFutureDate(dateString);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>